module.exports = __webpack_public_path__ + "img/Rettungsdienst.fe0a721c.svg";